// knowledge-base-frontend/app/ClientProviders.tsx
"use client";

import { ThemeProvider } from "@/shared/providers/theme-provider";
import ReactQueryProvider from "@/shared/providers/react-query-provider";
import { BFFAuthProvider } from "@/shared/providers/bff-auth-provider";
import { ProjectProvider } from "@/shared/contexts/ProjectContext";
import { Toaster } from "@/shared/components/ui/sonner";
import { TooltipProvider } from "@/shared/components/ui/tooltip";

export function ClientProviders({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      <BFFAuthProvider>
        <ReactQueryProvider>
          <ProjectProvider>
            <TooltipProvider>{children}</TooltipProvider>
            <Toaster richColors position="top-right" closeButton />
          </ProjectProvider>
        </ReactQueryProvider>
      </BFFAuthProvider>
    </ThemeProvider>
  );
}
